export default __webpack_public_path__ + "static/media/airpressure.55f8e41a.jpeg";